var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C0.895431 0 0 0.895431 0 2V18C0 19.1046 0.89543 20 2 20H13C14.1046 20 15 19.1046 15 18V5H10V0H2Z",
    fill: "#E5252A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5L10 0V5H15Z",
    fill: "#ED676A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3007 12.4508C4.68936 12.4508 5.0157 12.5773 5.2797 12.8303C5.5437 13.0833 5.6757 13.4059 5.6757 13.7983C5.6757 14.1906 5.5437 14.5133 5.2797 14.7663C5.0157 15.0193 4.68936 15.1458 4.3007 15.1458H3.7892V16.3008H2.8047V12.4508H4.3007ZM4.3007 14.2108C4.4107 14.2108 4.50236 14.1723 4.5757 14.0953C4.6527 14.0183 4.6912 13.9193 4.6912 13.7983C4.6912 13.6773 4.6527 13.5801 4.5757 13.5068C4.50236 13.4298 4.4107 13.3913 4.3007 13.3913H3.7892V14.2108H4.3007ZM7.62708 12.4508C8.15875 12.4508 8.60241 12.6359 8.95808 13.0063C9.31741 13.3729 9.49708 13.8294 9.49708 14.3758C9.49708 14.9221 9.31741 15.3804 8.95808 15.7508C8.60241 16.1174 8.15875 16.3008 7.62708 16.3008H6.05958V12.4508H7.62708ZM7.62708 15.3493C7.89475 15.3493 8.11291 15.2613 8.28158 15.0853C8.45025 14.9056 8.53458 14.6691 8.53458 14.3758C8.53458 14.0824 8.45025 13.8478 8.28158 13.6718C8.11291 13.4921 7.89475 13.4023 7.62708 13.4023H7.07158V15.3493H7.62708ZM12.3186 13.4023H10.9381V14.0293H12.2911V14.9808H10.9381V16.3008H9.95362V12.4508H12.3186V13.4023Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdfIcon.395e40aadb78e5655a43e557ce1d97c4.svg";
export { ForwardRef as ReactComponent };